import { AxiosError } from 'axios';

export const getAxiosErrorMessage = (error: unknown): string => {
  const axiosError = error as AxiosError<{
    errors?: { detail?: string }[];
    message?: string;
    error?: string;
  }>;
  return (
    // json api errors
    axiosError.response?.data?.errors?.[0]?.detail ||
    // fallbacks for non-standard response error messages
    axiosError.response?.data?.message ||
    axiosError.response?.data?.error ||
    axiosError.message ||
    'An unexpected error occurred'
  );
};
